import { useSelector } from 'react-redux';
import { replaceTokensInString, replaceTokensInUrl } from '@app/utils';
import links, { headlessLinks } from '@app/constants/links';
import { PCC_HEADLESS_QUOTES_DETAILS_PAGE } from '@app/constants/featureFlags';
const useQuotesPageFeatureFlag = () => {
    const esiteURL = useSelector(s => s.common?.esiteURL);
    const storeId = useSelector(s => s.common?.storeId);
    const langId = useSelector(s => s.common?.langId);
    const catalogId = useSelector(s => s.common?.catalogId);
    const isQuotesHeadlessEnabled = useSelector(s => s.featureFlag?.[PCC_HEADLESS_QUOTES_DETAILS_PAGE]) ?? false;
    const featureFlagDetails = {
        enabled: isQuotesHeadlessEnabled,
        redirectUrl: isQuotesHeadlessEnabled
            ? replaceTokensInString(headlessLinks.HEADLESS_PENDING_QUOTES, esiteURL)
            : replaceTokensInUrl(links.PENDING_QUOTES_URL, catalogId, langId, storeId)
    };
    return featureFlagDetails;
};
export default useQuotesPageFeatureFlag;
